import i18n from '@/i18n'
import axios from 'axios'
import { Message, MessageBox } from '@lui/lui-ui'
import { UserModule } from '@/store/modules/user'
import Utils from '@/utils/utiljs.js'
import Cookies from 'js-cookie'

let requestEuHost = false
const itmsSite = Cookies.get('itms-site') || 'sg'
if (process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'gray') {
  if (itmsSite === 'eu') {
    requestEuHost = true
  } else {
    requestEuHost = false
  }
} else {
  requestEuHost = false
}
const service = axios.create({
  baseURL: requestEuHost ? process.env.VUE_APP_EU_GW_HOST : process.env.VUE_APP_GW_HOST, // http://uat-us-gateway.jd.com',
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 24 * 3600 * 1000,
  withCredentials: true // 跨域时需要带上cookie需要开启
})

// 不需要拦截响应错误的url白名单
const urlWhiteList: any[] = [
  '/api/verifyTicket',
  '/erp/login',
  'erp/logout'
]

// Request 拦截
service.interceptors.request.use(

  async(config:any) => {
    // get local ip
    const ip: any = ''
    // try {
    //   ip = await Utils.getUserIP()
    // } catch (error) {
    //   console.log(error)
    // }
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    config.headers.tmslogintype = Cookies.get('itms.login.type') || 1
    // config.headers['LOP-DN'] = process.env.VUE_APP_GW_DOMAIN //'itms-jsf-web.jd.com'
    config.headers.clientIp = ip
    // config.headers['Content-Type'] = 'text/plain'
    // 白名单内不校验拦截器
    if (urlWhiteList.some(item => config.url.indexOf(item) > -1)) {
      return config
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response 拦截
service.interceptors.response.use(
  (response:any) => {
    // oidc接口拦截
    const { status, data } = response
    if (response.config.url.indexOf('/oidc/authorize') > -1) {
      return Promise.resolve(data)
    }
    const res = response.data
    // 白名单内不校验拦截器
    if (urlWhiteList.some(item => response.config.url.indexOf(item) > -1)) {
      return res
    }
    // 业务接口统一处理response异常
    if (res.code) {
      // switch (res.code) {
      //   case 2:
      //   case 65:
      //     Message(i18n.t('lib.request.334593-0'))
      //     break
      //   case 120:
      //     Message(i18n.t('lib.request.334593-1'))
      //     break
      //   default:
      //     // 条件 code !== 142 && code !== 143
      //     Message(i18n.t('lib.request.334593-2'))
      //     break
      // }
      return res// Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  async(error) => {
    // 针对401接口进行二次验证处理
    if (error.response && error.response.status === 401) {
      // # B账号登录地址
      // VUE_APP_URL_PULSAR_LOGIN = http://pulsar-login1.jd.com/login.html?ReturnUrl=http%3A%2F%2Ftest.ql.jd.com%3A8081%2F

      // # B账号登出地址
      // VUE_APP_URL_PULSAR_LOGOUT = http://pulsar-login1.jd.com/logout.html?ReturnUrl=http%3A%2F%2Ftest.ql.jd.com%3A8081%2F

      // # 多租户选择地址
      // VUE_APP_URL_TENANT_SELECT = http://pulsar-login1.jd.com/selectTenant?ReturnUrl=http%3A%2F%2Ftest.ql.jd.com%3A8081%2F
      window.location.href = `${process.env.VUE_APP_ERP_LOGIN_URL}?loginSoucre=itms&ReturnUrl=${encodeURIComponent(window.location.href)}`
      // const { headers: { location = '' }, config } = error.response
      // const { data: { type, value = '' } } = await service.get(location)
      // if (type === 'OIDC_CODE') {
      //   const _config = {
      //     ...config
      //   }
      //   _config.params ? _config.params.code = value : _config.params = { code: value }

      //   return service.request(_config)
      // }
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
